import React, {useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import classNames from 'classnames';

import messages from './messages';
import { ReactComponent as Overview } from '../svg/overview.svg';
import { ReactComponent as Discussion } from '../svg/discussion.svg';
import { ReactComponent as Progress } from '../svg/progress.svg';
import { ReactComponent as Instructor } from '../svg/instructor.svg';
import { ReactComponent as Date } from '../svg/date.svg';
import { Icon } from '@openedx/paragon';
import { Close } from "@openedx/paragon/icons";
import { ReactComponent as Menu } from "../courseware/course/customSidebar/svg/overview.svg";

import { useMobileResponsive, useOutsideClick } from '../utils';

function CourseTabsNavigation({
  activeTabSlug, className = null, tabs, courseName, intl,
}) {
  const navIcons = {
    outline: <Overview />,
    progress: <Progress />,
    discussion: <Discussion />,
    instructor: <Instructor />,
    dates: <Date />,
    "coordinator_tracking": <Progress />,
  };
  const [toggleSidebar, setIsToggleSidebar] = useState(false);

  const handleSidebar = () => {
    setIsToggleSidebar(!toggleSidebar);
  };

  const ref = useRef(null);
  useOutsideClick(() => {
    setIsToggleSidebar(false);
  }, ref);

  const isMobileView = useMobileResponsive(991);
  useEffect(() => {
    if (!isMobileView) {
      setIsToggleSidebar(false);
    }
  }, [isMobileView]);

  useEffect(() => {
    const [element] = document.getElementsByTagName("body");
    if (toggleSidebar) {
      element.classList.add("show-courses-sidebar");
    } else {
      element.classList.remove("show-courses-sidebar");
    }
  }, [toggleSidebar]);

  return (
    <>
      <div
        className={classNames("mb-sidebar-overlay", {
          "show-overlay": toggleSidebar,
        })}
      ></div>
      <div className="mh-100" ref={ref}>
        <div className="row">
          <div className="col-12 sidebar-toggle-btn-wrapper">
            <button
              onClick={() => handleSidebar()}
              aria-expanded={toggleSidebar ? "true" : "false"}
            >
              <Icon src={toggleSidebar ? Close : Menu} /> {intl.formatMessage(messages.overviewText)}
            </button>
          </div>
        </div>

        <div
          id="courseTabsNavigation"
          className={classNames(
            "course-tabs-navigation sidebarContainer h-100",
            { "show-mb-sidebar": toggleSidebar }
          )}
        >
          <div
            className="nav-underline-tabs w-100"
          >
            <div className="course-overview">
            <div className="d-lg-none d-flex justify-content-end mb-2">
                <button aria-label="Close Sidebar" className="reset-btn" onClick={handleSidebar}>
                  <Icon
                    src={Close}
                  />
                </button>
              </div>

              <h1 className="course-title">{courseName}</h1>
              {/* <div className="course-progress">
                <Progress /> Progress <span>50% Complete</span>
              </div> */}
            </div>

            <div className="external-links" aria-label={intl.formatMessage(messages.courseMaterial)}>
              <ul>
                {tabs.map(({ url, title, slug }) => (
                  <li
                    key={slug}
                    className={classNames({ active: slug === activeTabSlug })}
                  >
                    <a
                      className={classNames("btn", {
                        active: slug === activeTabSlug,
                      })}
                      href={url}
                    >
                      {navIcons[slug] || <Overview />}
                      <span className="nav-title">{messages[title] ? intl.formatMessage(messages[title]) : title}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

CourseTabsNavigation.propTypes = {
  activeTabSlug: PropTypes.string,
  className: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(CourseTabsNavigation);
